import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabButton", "tabPane"]

  submit(event) {
    event.currentTarget.form.requestSubmit()
  }

  switch(event) {
    this.activate(event.currentTarget.dataset.templateBuilderTabParam)
  }

  activate(tabName) {
    if (!tabName) return

    this.tabPaneTargets.forEach((pane) => {
      pane.classList.toggle("hidden", pane.id !== `template-tab-${tabName}`)
    })

    this.tabButtonTargets.forEach((button) => {
      const active = button.dataset.templateBuilderTabParam === tabName
      button.className = active
        ? "template-tab-button inline-flex h-8 items-center gap-1.5 rounded px-3 text-md font-semibold bg-white text-gray-900 shadow-sm"
        : "template-tab-button inline-flex h-8 items-center gap-1.5 rounded px-3 text-md font-semibold text-gray-500 hover:text-gray-900"
    })
  }
}
